"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

var warnOnce = require("@atlaskit/ds-lib/warn-once").default;

warnOnce("The '@atlaskit/icon-priority' package has been deprecated due to its limited usage in Cloud Products. If you depend on '@atlaskit/icon-priority' we recommend self-managing the assets.")

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PriorityMajorIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.02 5.187L5.567 9.05A1 1 0 114.54 7.335l6.97-4.173a1 1 0 011.03.002l6.906 4.173A1 1 0 1118.41 9.05l-6.39-3.862z" fill="#FF5630"/><path d="M5.567 15.054a1 1 0 11-1.027-1.716l6.97-4.174a1 1 0 011.03.002l6.906 4.174a1 1 0 11-1.035 1.712l-6.39-3.863-6.454 3.865z" fill="#FF7452"/><path d="M5.567 21.068a1 1 0 11-1.027-1.716l6.97-4.174a1 1 0 011.03.002l6.906 4.174a1 1 0 11-1.035 1.712l-6.39-3.863-6.454 3.865z" fill="#FF8F73"/></svg>`
}, props));

PriorityMajorIcon.displayName = 'PriorityMajorIcon';
var _default = PriorityMajorIcon;
exports.default = _default;
